import { boot } from "quasar/wrappers";
import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

export default boot(({ Vue }) => {
    Sentry.init({
        dsn: "https://911e552bfac44148b53d9753ee880ce4@o443325.ingest.sentry.io/4504006479183872",
        release: process.env.RELEASE,
        environment: process.env.ENV,
        integrations: [new BrowserTracing()],
        beforeSend(event, hint) {
            // Check if it is an exception, and if so, show the report dialog
            // if (event.exception) {
            //     Sentry.showReportDialog({ eventId: event.event_id });
            // }
            return event;
        },

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.2
    });
});